import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal', 'image'];

  open(event) {
    event.preventDefault();
    if (!this.hasModalTarget || !this.hasImageTarget) {
      console.error('Missing modal or image target for image-modal controller');
      return;
    }

    const imageUrl = event.currentTarget.getAttribute('data-image-url');
    this.imageTarget.src = imageUrl;
    this.modalTarget.showModal();
  }
}
